// V1 RBAC and Authorization types
// These types represent the database models for the authorization system.
// =============================================================================
// Roles
// =============================================================================
export var V1RoleName;
(function (V1RoleName) {
    V1RoleName["AGENCY_OWNER"] = "AGENCY_OWNER";
    V1RoleName["ACCOUNT_MANAGER"] = "ACCOUNT_MANAGER";
    V1RoleName["CONTENT_MANAGER"] = "CONTENT_MANAGER";
    V1RoleName["CREATOR"] = "CREATOR";
    V1RoleName["VIEWER"] = "VIEWER";
})(V1RoleName || (V1RoleName = {}));
// =============================================================================
// Creator Authorizations (creator ↔ org consent)
// =============================================================================
export var CreatorAuthorizationStatus;
(function (CreatorAuthorizationStatus) {
    CreatorAuthorizationStatus["PENDING"] = "PENDING";
    CreatorAuthorizationStatus["APPROVED"] = "APPROVED";
    CreatorAuthorizationStatus["REJECTED"] = "REJECTED";
    CreatorAuthorizationStatus["REVOKED"] = "REVOKED";
})(CreatorAuthorizationStatus || (CreatorAuthorizationStatus = {}));
// =============================================================================
// Content Approvals
// =============================================================================
export var ContentApprovalStatus;
(function (ContentApprovalStatus) {
    ContentApprovalStatus["PENDING"] = "PENDING";
    ContentApprovalStatus["APPROVED"] = "APPROVED";
    ContentApprovalStatus["REJECTED"] = "REJECTED";
})(ContentApprovalStatus || (ContentApprovalStatus = {}));
// =============================================================================
// Audit Events
// =============================================================================
export var AuditEventResult;
(function (AuditEventResult) {
    AuditEventResult["SUCCESS"] = "SUCCESS";
    AuditEventResult["FAILURE"] = "FAILURE";
})(AuditEventResult || (AuditEventResult = {}));
export var AuditAction;
(function (AuditAction) {
    // Creator authorization
    AuditAction["CREATOR_AUTHORIZATION_REQUESTED"] = "CREATOR_AUTHORIZATION_REQUESTED";
    AuditAction["CREATOR_AUTHORIZATION_APPROVED"] = "CREATOR_AUTHORIZATION_APPROVED";
    AuditAction["CREATOR_AUTHORIZATION_REJECTED"] = "CREATOR_AUTHORIZATION_REJECTED";
    AuditAction["CREATOR_AUTHORIZATION_REVOKED"] = "CREATOR_AUTHORIZATION_REVOKED";
    // User management
    AuditAction["USER_LOGIN"] = "USER_LOGIN";
    AuditAction["USER_LOGOUT"] = "USER_LOGOUT";
    AuditAction["USER_ROLE_CHANGED"] = "USER_ROLE_CHANGED";
    AuditAction["USER_CREATED"] = "USER_CREATED";
    AuditAction["USER_DEACTIVATED"] = "USER_DEACTIVATED";
    // Device
    AuditAction["DEVICE_ACCESSED"] = "DEVICE_ACCESSED";
    AuditAction["DEVICE_CONTROL_STARTED"] = "DEVICE_CONTROL_STARTED";
    AuditAction["APP_OPENED"] = "APP_OPENED";
    AuditAction["DEVICE_CONTROL_DENIED"] = "DEVICE_CONTROL_DENIED";
    AuditAction["DEVICE_STREAM_STARTED"] = "DEVICE_STREAM_STARTED";
    AuditAction["DEVICE_STREAM_DENIED"] = "DEVICE_STREAM_DENIED";
    AuditAction["DEVICE_ASSIGNED"] = "DEVICE_ASSIGNED";
    AuditAction["DEVICE_UNASSIGNED"] = "DEVICE_UNASSIGNED";
    AuditAction["DEVICE_REASSIGNED"] = "DEVICE_REASSIGNED";
    // Content
    AuditAction["CONTENT_UPLOADED"] = "CONTENT_UPLOADED";
    AuditAction["CONTENT_APPROVAL_REQUESTED"] = "CONTENT_APPROVAL_REQUESTED";
    AuditAction["CONTENT_APPROVED"] = "CONTENT_APPROVED";
    AuditAction["CONTENT_REJECTED"] = "CONTENT_REJECTED";
    AuditAction["CONTENT_APPROVAL_REVOKED"] = "CONTENT_APPROVAL_REVOKED";
    AuditAction["CONTENT_DELETED"] = "CONTENT_DELETED";
    /** Media was assigned to a creator, or made shared, after upload. */
    AuditAction["CONTENT_ASSIGNED"] = "CONTENT_ASSIGNED";
    // Social accounts
    AuditAction["SOCIAL_ACCOUNT_CONNECTED"] = "SOCIAL_ACCOUNT_CONNECTED";
    AuditAction["SOCIAL_ACCOUNT_DISCONNECTED"] = "SOCIAL_ACCOUNT_DISCONNECTED";
    AuditAction["SOCIAL_ACCOUNT_STATUS_CHANGED"] = "SOCIAL_ACCOUNT_STATUS_CHANGED";
    // Agency authorization requests
    AuditAction["AGENCY_REQUEST_CREATED"] = "AGENCY_REQUEST_CREATED";
    AuditAction["AGENCY_REQUEST_APPROVED"] = "AGENCY_REQUEST_APPROVED";
    AuditAction["AGENCY_REQUEST_REJECTED"] = "AGENCY_REQUEST_REJECTED";
    AuditAction["AGENCY_REQUEST_REVOKED"] = "AGENCY_REQUEST_REVOKED";
    // Posting
    /**
     * Reserved for V1 but not currently emitted. For V1, POST_SCHEDULED
     * represents post creation because the publishing job is created at
     * scheduling time — there is no separate "post created but not yet
     * scheduled" state in the current architecture. POST_CREATED is retained
     * for a possible future immediate-post feature that bypasses scheduling.
     */
    AuditAction["POST_CREATED"] = "POST_CREATED";
    AuditAction["POST_SCHEDULED"] = "POST_SCHEDULED";
    AuditAction["POST_EXECUTION_STARTED"] = "POST_EXECUTION_STARTED";
    AuditAction["POST_PUBLISHED"] = "POST_PUBLISHED";
    AuditAction["POST_FAILED"] = "POST_FAILED";
    AuditAction["POST_CANCELLED"] = "POST_CANCELLED";
    /** A post that had not gone out yet was edited (caption, hashtags, time or media). */
    AuditAction["POST_UPDATED"] = "POST_UPDATED";
    AuditAction["POST_BLOCKED_AUTHORIZATION"] = "POST_BLOCKED_AUTHORIZATION";
})(AuditAction || (AuditAction = {}));
// =============================================================================
// Permission evaluation result
// =============================================================================
export var AuthorizationResult;
(function (AuthorizationResult) {
    AuthorizationResult["ALLOW"] = "ALLOW";
    AuthorizationResult["DENY"] = "DENY";
})(AuthorizationResult || (AuthorizationResult = {}));
// =============================================================================
// Agency Authorization Requests (agency ↔ creator access requests)
// =============================================================================
export var AgencyAuthorizationRequestStatus;
(function (AgencyAuthorizationRequestStatus) {
    AgencyAuthorizationRequestStatus["PENDING"] = "pending";
    AgencyAuthorizationRequestStatus["APPROVED"] = "approved";
    AgencyAuthorizationRequestStatus["REJECTED"] = "rejected";
    AgencyAuthorizationRequestStatus["REVOKED"] = "revoked";
    AgencyAuthorizationRequestStatus["EXPIRED"] = "expired";
})(AgencyAuthorizationRequestStatus || (AgencyAuthorizationRequestStatus = {}));
//# sourceMappingURL=rbac.types.js.map